export default class Utilities {

  // expects div in rails view, e.g. <div id="url_id" url=<%= some_path.to_json %> ></div>
  static getRailsAttribute(divId, attributeName) {
    const node = document.getElementById(divId);
    return JSON.parse(node.getAttribute(attributeName));
  }

  static isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  static isEmpty(obj) {
    Object.keys(obj).length == 0 && obj.constructor == Object
  }

  static dateStringForInput(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1), //month is zero indexed
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
  }

  
}


